import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import reducers from './reducers';
import Modal from 'react-modal';
import App from './containers/App';
import './styles/index.scss';
import { composeWithDevTools } from 'redux-devtools-extension';
import * as Sentry from '@sentry/browser';

const middleware = process.env.NODE_ENV === 'production'
  ? [ thunk ]
  : [ thunk, createLogger() ];

const store = createStore(
  reducers,
  composeWithDevTools(applyMiddleware(...middleware))
);

Modal.setAppElement('#post-editor-app');

/**
 * initialize sentry
 */
if (window.hasOwnProperty('Config') && window.Config.hasOwnProperty('frontSentry')) {
  Sentry.init({
    dsn: window.Config.frontSentry,
    debug: true,
    release: '1.0.0',
  });
  Sentry.configureScope(scope => {
    scope.setExtra('Config', window.Config);
  });
}

ReactDOM.render(
  <Provider store={store}>
	  <App />
  </Provider>,
  document.getElementById('post-editor-app')
);
